import _ from 'lodash';

const size = v => _.trim(v).length;

export default {
  number: [
    {
      key: 'gt',
      text: 'Greater than',
      type: 'numeric',
      check: (v, a) => v > a
    },
    {
      key: 'ge',
      text: 'Greater than or equal to',
      type: 'numeric',
      check: (v, a) => v >= a
    },
    {
      key: 'lt',
      text: 'Less than',
      type: 'numeric',
      check: (v, a) => v < a
    },
    {
      key: 'le',
      text: 'Less than or equal to',
      type: 'numeric',
      check: (v, a) => v <= a
    },
    {
      key: 'e',
      text: 'Equal to',
      type: 'numeric',
      check: (v, a) => v === a
    },
    {
      key: 'ne',
      text: 'Not equal to',
      type: 'numeric',
      check: (v, a) => v !== a
    },
    {
      key: 'b',
      text: 'Between',
      type: 'range',
      check: (v, a, b) => a <= v && v <= b
    },
    {
      key: 'nb',
      text: 'Not between',
      type: 'range',
      check: (v, a, b) => v < a || v > b
    }
  ],
  text: [
    {
      key: 'matches',
      text: 'Matches',
      type: 'text',
      check: (v, a) => _.lowerCase(v) === _.lowerCase(a)
    },
    {
      key: 'contains',
      text: 'Contains',
      type: 'text',
      check: (v, a) => _.includes(v, a)
    },
    {
      key: 'not-contains',
      text: 'Doesn\'t contain',
      type: 'text',
      check: (v, a) => !_.includes(v, a)
    },
    {
      key: 'ge',
      text: 'Min character count',
      type: 'numeric',
      check: (v, a) => size(v) >= a
    },
    {
      key: 'lt',
      text: 'Max character count',
      type: 'numeric',
      check: (v, a) => size(v) <= a
    },
    {
      key: 'b',
      text: 'Character count between',
      type: 'range',
      check: (v, a, b) => size(v) >= a && size(v) <= b
    }
  ]
};
